// Customer editor access gates.
//
// Once a customer submits their album the order is awaiting our confirmation +
// payment, so the customer must NOT be able to keep editing. The customer-
// facing editor renders a "Votre album est soumis…" screen for these statuses
// instead of an editable surface.
//
// Scope: this covers only the just-submitted window. The later
// in-production / printed / shipped / delivered lock is owned separately by the
// editor pages (LOCKED_STATUSES) and is intentionally NOT duplicated here.
// The admin regen flow re-opens submitted orders on purpose and must bypass
// this gate at the call site.
export const AWAITING_CONFIRMATION_STATUSES = ['album-submitted'] as const;

export function isAwaitingConfirmation(status: string): boolean {
  return (AWAITING_CONFIRMATION_STATUSES as readonly string[]).includes(status);
}

// Admin "share for upload" window: the customer can re-enter a submitted album
// and APPEND photos until `upload_allowed_until` passes. The window is open iff
// the flag is set AND the expiry is still in the future (computed client-side so
// it self-closes without a server round-trip). See migration 018.
export function isUploadWindowOpen(
  session: { upload_allowed?: boolean; upload_allowed_until?: string | null } | null | undefined,
): boolean {
  if (!session?.upload_allowed) return false;
  if (!session.upload_allowed_until) return false;
  const until = Date.parse(session.upload_allowed_until);
  if (Number.isNaN(until)) return false;
  return Date.now() < until;
}
